import { createWebHistory } from 'vue-router'
import createRouter from '@/pages/routes.js'
import { useAuth } from '@/composables/auth'

const router = createRouter(createWebHistory(import.meta.env.BASE_URL))
const baseUrl = import.meta.env.BASE_URL
router.beforeEach((to, from) => {
  document.title = ['SyncFdy', typeof to.meta?.title === 'function' ? to.meta?.title(to) : to.meta?.title?.toString()].filter(x => x).join(' - ')
})
router.beforeEach((to, from) => {
  const { isAuthenticated } = useAuth()
  if (
    !isAuthenticated.value &&
    to.name !== 'Login'
  ) {
    return { name: 'Login', query: { redirectTo: baseUrl + to.path } }
  } else if (
    isAuthenticated.value &&
    to.name === 'Login'
  ) {
    return { name: 'Home' }
  }
})

export default router
